import { createStore, applyMiddleware } from 'redux';
import { logger } from 'redux-logger';
import { RootReducer } from '../reducers/ReducersIndex';
import { ClientStateService } from '../services/ClientStateService';


const ApiMiddleware = (store) => (next) => (action) => {
    next(action);
    let searchData = store.getState().SearchData;
    let visit = store.getState().Visit;
    if (searchData) {
        let service = new ClientStateService();
        // console.log("SaveState 1: " + searchData.SelectedDateFrom);
        if (searchData.SelectedDateFrom !== undefined) {
            // console.log("SaveState 1: " + (searchData.SelectedDateFrom as Date).toDateString());
        }
        service.SaveState({
            //Nie zapisywać ProfileInfo!
            SearchData: searchData,
            Visit: visit
        }, ApiSuccess, ApiError);
    }
}

function ApiSuccess(result) {
}

function ApiError(error) {
    console.error(error);
}

export function ConfigureStore(initialState) {
    return createStore(RootReducer, applyMiddleware(logger, ApiMiddleware));
}


// WEBPACK FOOTER //
// ./src/stores/ConfigureStore.tsx